import * as React from 'react';

const Ie24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#169B62", d: "M8.956 6H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3.956z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M15.044 6H8.956v12h6.088z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FF883E", d: "M19 6h-4v12h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2" }));
Ie24.Size = 24;
Ie24.Title = "Ie";

export { Ie24 as default };
